import { PUSH_LINK_TO_GLOBAL_STATE } from "../constants/linkConstants";

export const pushLinkToGlobalState = (stringToAdd) => {
  return {
    type: PUSH_LINK_TO_GLOBAL_STATE,
    payload: stringToAdd,
  };
};
